module.exports = __webpack_public_path__ + "assets/images/img/invite_players/settings_ios_xrivals.1fd720c76569ecd40b86774af5988fa9.png";